import { MasterConfigContext } from "@/context/MasterConfigContext";
import { getDataFromSSR } from "@/handlers/client/commonClient";
import { parseMatchDetails } from "@/utils/ipl";

import { usePathname } from "next/navigation";
import { useContext, useEffect, useState } from "react";
import SVG from "react-inlinesvg";
const IPLMainWidget = ({
  topicNewsList = [],
  pointsData = null,
  matchData = null,
}) => {
  const [liveMatch, setLiveMatch] = useState(matchData);
  const pathname = usePathname();
  const masterConfig = useContext(MasterConfigContext);
  const iplKeys = masterConfig["ipl_2025"];
  const menuItems = [
    { name: "Home", path: "/sports/ipl" },
    ...(iplKeys?.showPointsTableTab
      ? [{ name: "Point Table", path: "/sports/ipl/points-table" }]
      : []),
    ...(iplKeys?.showScheduleTab
      ? [{ name: "Schedule", path: "/sports/ipl/schedule" }]
      : []),
    ...(iplKeys?.showMatchesTab
      ? [{ name: "Matches", path: "/sports/ipl/live" }]
      : []),
    ...(iplKeys?.showStatsTab
      ? [{ name: "Stats", path: "/sports/ipl/stats" }]
      : []),
    ...(iplKeys?.showPurpleCap
      ? [{ name: "Purple Cap", path: "/sports/ipl/purple-cap" }]
      : []),
    ...(iplKeys?.showOrangeCap
      ? [{ name: "Orange Cap", path: "/sports/ipl/orange-cap" }]
      : []),
  ];
  useEffect(() => {
    //get live match
    if (matchData.status == "LIVE") {

      async function getMatches() {
        const timeStamp = Date.now();
        const matches = await getDataFromSSR(
          `/api/getLiveMatchDetails?matchId=${matchData.id}&time=${timeStamp}`
        );

        if (matches && matches.data?.data) {
          const matchStats = parseMatchDetails(matches.data?.data);
          setLiveMatch(matchStats);
        }
      }

      getMatches();
      const interval = setInterval(() => {
        getMatches();
      }, 10000);

      return () => clearInterval(interval);
    }
  }, []);

  return (
    <div className="relative max-h-fit w-full text-white px-4 md:px-8 pt-2 pb-4">
      {/* gradients  */}
      <div
        className="absolute hidden md:block inset-0 z-10"
        style={{
          background:
            "linear-gradient(to right, black 1%, transparent 60%, black 99%)",
        }}
      />
      <div
        className="absolute hidden md:block inset-0 z-10"
        style={{
          background:
            "linear-gradient(to bottom, black 1%,transparent 25%, transparent 90%)",
        }}
      />
      <div
        className="absolute md:hidden inset-0 z-10"
        style={{
          background: `linear-gradient(to bottom, black 5%, transparent 15%, transparent, black 50% )`,
        }}
      />
      <div
        className="absolute md:hidden inset-0 -z-2 bg-cover bg-center h-[50%]"
        style={{
          backgroundImage: `url(${topicNewsList[0]?.image_small})`,
        }}
      />

      <div
        className="absolute hidden md:block inset-0 -z-2 bg-cover bg-center h-full"
        style={{
          backgroundImage: `url(${topicNewsList[0]?.image_small})`,
        }}
      />
      {/* gradients end  */}

      {/* Scrollable Navigation Mobile */}
      <div
        className="md:hidden relative overflow-x-auto scrollbar-hide whitespace-nowrap w-full z-10 mt-2"
        style={{ scrollbarWidth: "none" }}
      >
        <div className="flex space-x-2">
          {menuItems.map((item) => (
            <a
              key={item.name}
              href={`${process.env.NEXT_PUBLIC_WEBSITE_URL}${item.path}`}
              className={`px-4 py-2 rounded-lg text-white text-sm ${pathname === item.path
                ? "bg-primary border border-primary"
                : "border text-white text-sm hover:text-primary hover:border-primary"
                }`}
              target={"_self"}
            >
              {item.name}
            </a>
          ))}
        </div>
      </div>
      <div className="flex items-center justify-between mb-6 mt-2">
        <img
          src="https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/t-20-01.png"
          height={90}
          width={90}
          className="relative z-10"
          alt="ipl logo"
        />
        {/* Scrollable Navigation */}
        <div
          className="hidden md:block w-full overflow-x-auto scrollbar-hide whitespace-nowrap mx-4 z-10 -mt-10"
          style={{ scrollbarWidth: "none" }}
        >
          <div className="flex space-x-2">
            {menuItems.map((item) => (
              <a
                key={item.name}
                href={`${process.env.NEXT_PUBLIC_WEBSITE_URL}${item.path}`}
                className={`px-4 py-2 rounded-lg text-white text-sm ${pathname === item.path
                  ? "bg-primary border border-primary"
                  : "border text-white text-sm hover:text-primary hover:border-primary"
                  }`}
                target={"_self"}
              >
                {item.name}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="relative z-10 flex flex-col md:flex-row mt-6 md:mt-16">
        {/* news list */}
        <div className="text-white w-full mt-16 md:mt-0 md:w-[50%] border-white">
          <h1 className="font-extralight text-md">IPL 2025</h1>
          {topicNewsList.slice(0, 3).map((item, index) => {
            return index == 0 ? (
              <a key={index} href={item?.canonical_url}>
                <p className="text-xl font-semibold mt-2 border-b-[0.03rem] pb-3 md:border-none md:pb-1 md:mb-14 flex items-start justify-start gap-1">
                  <SVG
                    src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/story.svg"
                    className="w-[40px] h-[40px] -mt-2"
                  />
                  <span className="line-clamp-3">{item.title_short}</span>
                </p>
              </a>
            ) : (
              <a key={index} href={item?.canonical_url}>
                <p
                  key={index}
                  className="text-md font-light my-2 py-4 flex items-start justify-start gap-1 border-b-[0.03rem] line-clamp-2"
                >
                  <SVG
                    src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/story1.svg"
                    className="w-4 h-4 mt-1"
                  />

                  <span className="line-clamp-2 md:line-clamp-3">
                    {item.title_short}
                  </span>
                </p>
              </a>
            );
          })}
          <a href="/sports">
            <span className="flex items-center font-semibold justify-end md:justify-start gap-2 my-4 md:mt-10">
              और देखें
              <SVG
                src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/arrow-right.svg"
                className="w-6 h-6"
              />
            </span>
          </a>
        </div>

        <div className="w-full md:w-[50%] px-1 container">
          {/* live match card  */}
          {iplKeys?.showLiveCard && liveMatch && (
            <a href={liveMatch?.url || "/sports/ipl"}>
              <div className="hidden md:flex flex-col items-center md:items-start justify-start gap-0 md:pl-[20%] mb-2 mt-12 md:mt-0">
                <div className="w-[90%] md:w-[95%] bg-slate-200 border-b border-white text-black bg-opacity-90 flex justify-between py-1 px-2 items-center rounded-t-md">
                  <div className="flex items-center gap-1">
                    <span className="text-sm">IPL 2025</span>
                    <span className="rounded-full bg-gray-400 w-1 h-1"></span>
                    <span className="text-black text-sm">
                      {liveMatch?.match_no}
                    </span>
                  </div>
                  <span className="flex items-center gap-1 text-sm font-semibold">
                    {liveMatch.status == "LIVE" ? "LIVE" : "ENDED"}
                    {liveMatch.status == "LIVE" && (
                      <img
                        height={24}
                        width={24}
                        src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/liveGif.gif"
                        alt="live icon"
                      />
                    )}
                  </span>
                </div>
                <div className="w-[90%] md:w-[95%] bg-slate-200 bg-opacity-90 px-2 py-1 text-black">
                  <span className="flex items-center gap-2 mb-2">
                    <img
                      width={24}
                      height={24}
                      src={` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${liveMatch?.teamA_name}1.png`}
                      alt="teamA logo"
                    // className="rounded-full"
                    />
                    <span className="flex tiems-center gap-1 text-xs font-[600]">
                      {liveMatch?.teamA_name?.toUpperCase()}
                      {liveMatch?.winning_team == "A" && (
                        <img
                          src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/trophy.gif"}
                          width={20}
                          height={20}
                          alt="trophy gif"
                          className="-mt-1"
                        />
                      )}
                    </span>
                    <span
                      className={`text-sm ml-auto ${liveMatch?.batting_team == "A" ||
                        liveMatch?.winning_team == "A"
                        ? "font-semibold"
                        : "mr-1"
                        }`}
                    >
                      {liveMatch.teamA_score
                        ? liveMatch.teamA_score + "  "
                        : "Yet To Bat"}
                      {liveMatch.teamA_overs
                        ? "(" + liveMatch.teamA_overs + ")"
                        : ""}
                      {liveMatch?.batting_team == "A" && (
                        <span className="text-primary text-md font-semibold">
                          *
                        </span>
                      )}
                    </span>
                  </span>
                  <span className="flex items-center gap-2 mb-1">
                    <img
                      width={24}
                      height={24}
                      src={` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${liveMatch?.teamB_name}1.png`}
                      alt="teamA logo"
                    // className="rounded-full"
                    />
                    <span className="flex items-center gap-1 text-xs font-[600]">
                      {liveMatch?.teamB_name?.toUpperCase()}
                      {liveMatch?.winning_team == "B" && (
                        <img
                          src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/trophy.gif"}
                          width={20}
                          height={20}
                          alt="trophy gif"
                          className="-mt-1"
                        />
                      )}
                    </span>
                    <span
                      className={`text-sm ml-auto ${liveMatch?.batting_team == "B" ||
                        liveMatch?.winning_team == "B"
                        ? "font-semibold"
                        : "mr-1"
                        }`}
                    >
                      {liveMatch.teamB_score
                        ? liveMatch.teamB_score + "  "
                        : "Yet To Bat"}
                      {liveMatch.teamB_overs
                        ? "(" + liveMatch.teamB_overs + ")"
                        : ""}
                      {liveMatch?.batting_team == "B" && (
                        <span className="text-primary text-md font-semibold">
                          *
                        </span>
                      )}
                    </span>
                  </span>
                </div>
                <div className="w-[90%] md:w-[95%] bg-slate-200 text-black bg-opacity-90 rounded-b-md">
                  <div className="w-[full] mb-1 text-center bg-white text-sm">
                    {liveMatch?.equation}
                  </div>
                </div>
              </div>
            </a>
          )}

          {/* points table  */}
          {pointsData && (
            <div className="hidden md:flex flex-col items-center md:items-start justify-start gap-0 md:pl-[20%]">
              <div className="w-[90%] md:w-[95%] flex items-center text-white text-lg justify-between">
                <span>Points Table</span>
                <a href="/sports/ipl/points-table">
                  <span className="flex items-center gap-1 text-sm">
                    View Points Table
                    <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/send2.svg" />
                  </span>
                </a>
              </div>
              <div className="w-[90%] md:w-[95%] bg-white text-black flex justify-between p-2 items-center rounded-t-md">
                <div className="w-[45%] text-sm">Teams</div>
                <div className="w-[55%] text-sm flex justify-between items-center gap-2">
                  <div className="w-[20%]">P</div>
                  <div className="w-[20%]">W</div>
                  <div className="w-[20%]">L</div>
                  <div className="w-[20%]">D</div>
                  <div className="w-[40%]">NRR</div>
                  <div className="w-[20%]">Pts</div>
                </div>
              </div>
              {pointsData?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`w-[90%] md:w-[95%] bg-slate-200 text-sm flex items-center justify-between text-black  ${index % 2 == 0 ? "bg-opacity-90" : "bg-opacity-70"
                      } ${index == 4 ? "rounded-b-md" : ""} p-2`}
                  >
                    <div className="w-[45%] flex items-center gap-1">
                      <img
                        width={24}
                        height={24}
                        alt="point_team"
                        src={` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${item?.short_name?.toLowerCase()}1.png`}
                      />
                      <span>{item?.short_name || "RCB"}</span>
                    </div>
                    <div className="w-[55%] flex items-center justify-between gap-2">
                      <div className="w-[20%]">
                        <span>{item?.p || 0}</span>
                      </div>
                      <div className="w-[20%]">
                        <span>{item?.w || 0}</span>
                      </div>
                      <div className="w-[20%]">
                        <span>{item?.l || 0}</span>
                      </div>
                      <div className="w-[20%]">
                        <span>{item?.t || 0}</span>
                      </div>
                      <div className="w-[40%]">
                        <span>{item?.nrr || "-"}</span>
                      </div>
                      <div className="w-[20%] text-center">
                        <span>{item?.pts || 0}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default IPLMainWidget;
